'use client';

import React from 'react';

import {
  footerData,
  getCertifications,
  getFooterSections,
} from '@/data/footerData';

import { FooterBottom } from './FooterBottom';
import { FooterSection } from './FooterSection';
import FooterSocials from './FooterSocials';

/**
 * Main Footer component - now simplified and focused
 *
 * Responsibilities:
 * - Layout structure
 * - Data coordination
 * - Component composition
 */
const Footer: React.FC = () => {
  const sections = getFooterSections();
  const certifications = getCertifications();

  return (
    <footer className="bg-indigo-900 pb-8 text-white" data-inverse>
      <div className="mx-auto w-full max-w-[1536px] px-6 py-16 sm:px-8 md:px-12 lg:px-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,10rem),1fr))] gap-x-6 gap-y-12 md:grid-cols-3 xl:grid-cols-6 xl:gap-x-8">
          {sections.map((section) => (
            <div key={section.id} className="min-w-0">
              <FooterSection section={section} />
            </div>
          ))}
          {/* Social Media Links */}
          <div className="min-w-0">
            <FooterSocials socialLinks={footerData.socialLinks} />
          </div>
        </div>

        <div className="text-Mulish my-6 flex flex-col items-center justify-between gap-4 py-6 md:flex-row">
          <svg
            xmlns="http://w3.org"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-6 w-6 text-white/20 md:h-16 md:w-16"
          >
            <circle cx="12" cy="12" r="10" />
            <circle cx="12" cy="7" r="0.5" fill="currentColor" />
            <line x1="12" y1="11" x2="12" y2="17" />
          </svg>
          <p>{footerData.exclaimer}</p>
        </div>

        {/* Footer Bottom */}
        <FooterBottom certifications={certifications} />
      </div>
    </footer>
  );
};

export default Footer;
